import React, { useState, useEffect } from "react";
import { LearningActivityCardLink } from "Components/Module/LearningActivityItem/Actions";
import config from "lib/config";
import * as CONSTANTS from "./constants";
import {
  ComputerIcon as ONLINE,
  ContactsIcon as CLASSROOM,
  DirectionsRunIcon as ACTIVITY,
} from "Components/Icons";

import { GET } from "Common/api";

export const getCourseOnlineLinkLabel = (course, reRegisterLink) => {
  if (!course.lastLoggedIn) {
    return "start";
  }

  if (course.completed) {
    return "show";
  }

  return "continue";
};

export const reRegistrationPossible = (course) => {
  if (course.completed && course.allowUserReRegistration) {
    return true;
  }

  return false;
};

export const getProgressBgColor = (course) => {
  let progressColor = CONSTANTS.COURSE_COLOR_PROGRESS_NEUTRAL;

  if (!course || course === "") {
    return progressColor;
  }

  const PROGRESS_LOW = course.completed === false;
  const PROGRESS_MEDIUM =
    course.completed === false && course.progress && course.progress > 30;
  const PROGRESS_HIGH = course.completed === true;

  if (PROGRESS_LOW) {
    progressColor = CONSTANTS.COURSE_COLOR_PROGRESS_NEUTRAL;
  }
  if (PROGRESS_MEDIUM) {
    progressColor = CONSTANTS.COURSE_COLOR_PROGRESS_MEDIUM;
  }
  if (PROGRESS_HIGH) {
    progressColor = CONSTANTS.COURSE_COLOR_PROGRESS_HIGH;
  }
  return progressColor;
};

export const getProgressColor = (course) => {
  let progressColor = CONSTANTS.COLOR_1;

  if (!course || course === "") {
    return progressColor;
  }

  const PROGRESS_LOW = course.completed === false;
  const PROGRESS_MEDIUM =
    course.completed === false && course.progress && course.progress > 30;
  const PROGRESS_HIGH = course.completed === true;

  if (PROGRESS_LOW) {
    progressColor = CONSTANTS.COLOR_1;
  }
  if (PROGRESS_MEDIUM) {
    progressColor = CONSTANTS.COLOR_1;
  }
  if (PROGRESS_HIGH) {
    progressColor = CONSTANTS.COLOR_4;
  }
  return progressColor;
};

export const getFullName = (person) => {
  let { firstName = "", lastName = "" } = person;

  if (firstName === null) {
    firstName = "";
  }
  if (lastName === null) {
    lastName = "";
  }

  return `${firstName} ${lastName}`.trim();
};

export const getIconBackgroundColor = (type) => {
  if (type == CONSTANTS.COURSE_TYPE_ONLINE) {
    return CONSTANTS.COLOR_COURSE_ONLINE;
  }
  if (type == CONSTANTS.COURSE_TYPE_CLASSROOM) {
    return CONSTANTS.COLOR_COURSE_CLASSROOM;
  }
  if (
    type == CONSTANTS.COURSE_TYPE_ACTIVITY ||
    CONSTANTS.COURSE_TYPE_COMMON_ACTIVITY
  ) {
    return CONSTANTS.COLOR_COURSE_ACTIVITY;
  }
};

export const getCardBackgroundColor = (type) => {
  if (type === CONSTANTS.COURSE_TYPE_ONLINE) {
    return CONSTANTS.COLOR_COURSE_ONLINE_BACKGROUND;
  }
  if (type === CONSTANTS.COURSE_TYPE_CLASSROOM) {
    return CONSTANTS.COLOR_COURSE_CLASSROOM_BACKGROUND;
  }
  if (
    type === CONSTANTS.COURSE_TYPE_ACTIVITY ||
    CONSTANTS.COURSE_TYPE_COMMON_ACTIVITY
  ) {
    return CONSTANTS.COLOR_COURSE_ACTIVITY_BACKGROUND;
  }
};

export const getProgramTypeIcon = (type) => {
  if (type === CONSTANTS.COURSE_TYPE_ONLINE) {
    return <ONLINE size={CONSTANTS.ICON_SIZE} color={CONSTANTS.COLOR_4} />;
  }
  if (type === CONSTANTS.COURSE_TYPE_CLASSROOM) {
    return <CLASSROOM size={CONSTANTS.ICON_SIZE} color={CONSTANTS.COLOR_4} />;
  }
  if (
    type === CONSTANTS.COURSE_TYPE_ACTIVITY ||
    CONSTANTS.COURSE_TYPE_COMMON_ACTIVITY
  ) {
    return <ACTIVITY size={CONSTANTS.ICON_SIZE} color={CONSTANTS.COLOR_4} />;
  }
};

export const filterProgramContent = (steps, selection) => {
  if (selection === CONSTANTS.PROGRESS_ALL) {
    return steps;
  }

  return steps.filter((step) => {
    const ONLINE_STEP = step.type === CONSTANTS.COURSE_TYPE_ONLINE;
    let progress = CONSTANTS.PROGRESS_TODO;

    if (step.completed) {
      progress = CONSTANTS.PROGRESS_DONE;
    }
    if (!step.completed) {
      const filterOnlineStepAsOngoing =
        ONLINE_STEP &&
        step.progress &&
        step.progress > 0 &&
        selection === CONSTANTS.PROGRESS_ONGOING;
      if (filterOnlineStepAsOngoing) {
        progress = CONSTANTS.PROGRESS_ONGOING;
      }
    }

    return progress === selection;
  });
};

export const getProgramProgress = (program) => {
  const { steps } = program;

  let numberOfProgramSteps = 0;
  let completedSteps = 0;
  steps.forEach((step) => {
    if (step.completed && step.mandatory) {
      completedSteps++;
    }
    if (step.mandatory) {
      numberOfProgramSteps++;
    }
  });

  return Math.round((completedSteps / numberOfProgramSteps) * 100) || 0;
};

export const GetRequestedCourseLink = (props) => {
  const { courseId, label, activityId, isPortalOverview } = props;

  let fromString = isPortalOverview ? "pr" : "ov";

  return (
    <LearningActivityCardLink
      href={`${config.urlRoot}activities/ActivityDetails.aspx?m=${fromString}&prid=${activityId}&inapp=1&id=${courseId}`}
    >
      {label}
    </LearningActivityCardLink>
  );
};

export const GetRequestedCourseCatlogueLink = (props) => {
  const { courseId, label, activityId } = props;

  return (
    <LearningActivityCardLink
      href={`${config.urlRoot}activities/ActivityApplication.aspx?id=${activityId}&pid=${config.personalId}&coid=${courseId}&prid=`}
    >
      {label}
    </LearningActivityCardLink>
  );
};

export const GetRequestedOnlineCourseCatlogueLink = (props) => {
  const { courseId, label, isPortalOverview } = props;

  let fromString = isPortalOverview ? "ov" : "pr";

  return (
    <LearningActivityCardLink
      href={`${config.urlRoot}activities/onlinecoursedetails.aspx?m=${fromString}&inapp=1&courseid=${courseId}`}
    >
      {label}
    </LearningActivityCardLink>
  );
};

export const navigateToMsTeams = async (activityId) => {
  let url = await GET("v1/msteams/url/:activityId/", {
    activityId,
  });

  if (url) {
    let win = window.open(url, "_blank");
    win.focus();
  }
};

export const useCourseCompletion = (course) => {
  const [completed, setCompleted] = useState(course.completed);

  useEffect(() => {
    setCompleted(course.completed);
  }, [course]);

  return [completed, setCompleted];
};

export const groupProgramSteps = (steps) => {
  const blocks = [];

  steps.forEach((step) => {
    const groupId = step.programStepGroupID || 0;
    const lastBlock = blocks[blocks.length - 1];

    if (lastBlock && lastBlock.groupId === groupId) {
      lastBlock.steps.push(step);
    } else {
      blocks.push({
        key: `programstepgroup-${blocks.length}-${groupId}`,
        groupId,
        title: step.programStepGroupTitle,
        steps: [step],
      });
    }
  });

  return blocks;
};

export const getDisplayDescription = (course, isPortalOverview) => {
  const description = course.stepDescription || course.itemDescription;
  const shouldDisplay =
    course.itemDescription &&
    course.itemDescription !== "" &&
    !isPortalOverview;

  return {
    description,
    shouldDisplay,
  };
};
